export const lunchMenuDate = "20.10.2026";

const lunchSections = [
  {
    title: "Супи",
    title_en: "Soups",
    items: [
      {
        name: "Супа леща",
        name_en: "Lentil Soup",
        desc: "",
        desc_en: "",
        weight: "300 г",
        weight_en: "300 g",
        price: "3.90 €",
        active: true,
      },
    ],
  },
  {
    title: "Салати",
    title_en: "Salads",
    items: [
      {
        name: "Салата Капрезе",
        name_en: "Caprese Salad",
        desc: "",
        desc_en: "",
        weight: "200 г",
        weight_en: "200 g",
        price: "6.40 €",
        active: true,
      },
    ],
  },
  {
    title: "Паста",
    title_en: "Pasta",
    items: [
      {
        name: "Равиоли с рикота и спанак със сос 4 формаджи",
        name_en: "Ricotta and Spinach Ravioli with Four-Cheese Sauce",
        desc: "",
        desc_en: "",
        weight: "350 г",
        weight_en: "350 g",
        price: "6.90 €",
        active: true,
      },
    ],
  },
  {
    title: "Основни ястия",
    title_en: "Main Courses",
    items: [
      {
        name: "Свинско бон филе су вид с манатарки и картофено пюре",
        name_en: "Sous Vide Pork Tenderloin with Porcini Mushrooms and Mashed Potatoes",
        desc: "",
        desc_en: "",
        weight: "350 г",
        weight_en: "350 g",
        price: "13.90 €",
        active: true,
      },
    ],
  },
  {
    title: "Десерти",
    title_en: "Desserts",
    items: [
      {
        name: "Бисквитена торта",
        name_en: "Biscuit Cake",
        desc: "",
        desc_en: "",
        weight: "170 г",
        weight_en: "170 g",
        price: "6.90 €",
        active: true,
      },
    ],
  },
];

export default lunchSections;
